// extracted by mini-css-extract-plugin
module.exports = {"inlineLabel":"InlineLabel_inlineLabel__1n6F0","withImage":"InlineLabel_withImage__3oKh6","imageRadius":"InlineLabel_imageRadius__1lPbo"};